<template>
  <el-select
    :value="normalizedValue"
    multiple
    filterable
    clearable
    :filter-method="onFilter"
    :placeholder="placeholder"
    :loading="loading"
    :size="size"
    style="width: 100%"
    class="cc-user-select"
    @input="onInput"
    @visible-change="onVisible"
  >
    <el-option
      v-for="u in displayOptions"
      :key="u.id"
      :label="optionLabel(u)"
      :value="u.id"
      class="cc-option-item"
    >
      <div class="cc-option">
        <user-avatar
          :name="u.name"
          :username="u.username"
          :avatar="u.avatar"
          :user-id="u.id"
          size="sm"
        />
        <span class="cc-name">{{ u.name }}</span>
        <span
          v-if="u.departmentName"
          class="cc-dept-tag"
          :style="deptStyle(u.departmentName)"
        >{{ u.departmentName }}</span>
      </div>
    </el-option>
  </el-select>
</template>

<script>
import UserAvatar from "./UserAvatar.vue";

const DEPT_PALETTE = [
  { color: "#1d6fd8", bg: "#e8f1fc" },
  { color: "#0d9488", bg: "#e6f7f5" },
  { color: "#c2410c", bg: "#fff1e8" },
  { color: "#7c3aed", bg: "#f3edff" },
  { color: "#b45309", bg: "#fff7e6" },
  { color: "#be123c", bg: "#ffe8ee" },
  { color: "#0369a1", bg: "#e6f4fb" },
  { color: "#15803d", bg: "#e8f8ee" },
  { color: "#a16207", bg: "#faf3e0" },
  { color: "#475569", bg: "#eef1f5" },
];

function hashStr(s) {
  let h = 0;
  const str = String(s || "");
  for (let i = 0; i < str.length; i++) {
    h = (h * 31 + str.charCodeAt(i)) >>> 0;
  }
  return h;
}

function toId(v) {
  const n = Number(v);
  return isNaN(n) ? null : n;
}

export default {
  name: "CcUserSelect",
  components: { UserAvatar },
  props: {
    value: { type: Array, default: () => [] },
    options: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    placeholder: { type: String, default: "选择抄送员工（可选）" },
    size: { type: String, default: "small" },
  },
  data() {
    return {
      keyword: "",
    };
  },
  computed: {
    normalizedOptions() {
      return (this.options || [])
        .map((u) => ({ ...u, id: toId(u.id) }))
        .filter((u) => u.id != null);
    },
    normalizedValue() {
      return (this.value || []).map(toId).filter((id) => id != null);
    },
    filteredOptions() {
      const kw = (this.keyword || "").trim().toLowerCase();
      if (!kw) return this.normalizedOptions;
      return this.normalizedOptions.filter((u) => {
        const hay = [u.name, u.username, u.departmentName]
          .filter(Boolean)
          .join(" ")
          .toLowerCase();
        return hay.indexOf(kw) >= 0;
      });
    },
    // 已选项必须始终在 option 列表中，否则标签会显示成 id
    displayOptions() {
      const map = {};
      this.filteredOptions.forEach((u) => {
        map[u.id] = u;
      });
      this.normalizedValue.forEach((id) => {
        if (!map[id]) {
          const found = this.normalizedOptions.find((u) => u.id === id);
          if (found) map[id] = found;
        }
      });
      return Object.keys(map).map((k) => map[k]);
    },
  },
  methods: {
    onInput(val) {
      this.$emit(
        "input",
        (val || []).map(toId).filter((id) => id != null)
      );
    },
    optionLabel(u) {
      const dept = u.departmentName ? `（${u.departmentName}）` : "";
      return `${u.name || ""}${dept}`;
    },
    deptStyle(deptName) {
      const p = DEPT_PALETTE[hashStr(deptName) % DEPT_PALETTE.length];
      return {
        color: p.color,
        backgroundColor: p.bg,
        borderColor: p.color,
      };
    },
    onFilter(query) {
      this.keyword = query;
    },
    onVisible(visible) {
      if (!visible) this.keyword = "";
    },
  },
};
</script>

<style scoped>
.cc-option {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 28px;
  line-height: 28px;
  overflow: hidden;
}
.cc-name {
  font-size: 13px;
  font-weight: 500;
  color: #303133;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 160px;
}
.cc-dept-tag {
  font-size: 12px;
  border-radius: 3px;
  padding: 0 6px;
  line-height: 18px;
  border: 1px solid transparent;
  white-space: nowrap;
  flex-shrink: 0;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>

<style>
.cc-user-select .el-select-dropdown__item {
  height: 34px;
  line-height: 34px;
  padding-top: 3px;
  padding-bottom: 3px;
}
.cc-user-select .el-tag {
  max-width: 100%;
}
</style>
